import { useContext, useEffect, useRef } from "react";
import { EmbedConfigContext, authOptionsKey, baseOptionsKey } from "../EmbedConfigContext";
import useAuthProvider from "../useAuthProvider";


const LibraryPage = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const {config} = useContext(EmbedConfigContext)
  const authParams = useAuthProvider(config[authOptionsKey], config[baseOptionsKey].backend)

  useEffect(() => {
    if (!window.GleanWebSDK) return;

    const settingsCustomConfig = {
      ...config[baseOptionsKey],
    }

    containerRef.current && window.GleanWebSDK.renderLibrary(containerRef.current, {
      ...settingsCustomConfig,
      ...authParams,
      ...{ hideUnconfigurableDatasources: true}
    });
  }, [config, authParams]);

  return (
    <div
      className="h-full w-full relative"
      ref={containerRef}
    >
    </div>
  );
};

export default LibraryPage;
